<style>

.time{
  font-size: 17px;
}

</style>

<div class="time">{rendered}</div>

<script>

// current time can be incremented by the parent of the component.
// it basically allows one interval timer to update the current time and all
// components will then update based on $:{}
export let currentTime = 0;
export let startsAt = 0;
export let endsAt = 0;

$:{
  if (startsAt || endsAt || currentTime) {
    render();
  }
}

let rendered = "";
function render() {
  const now = new Date();
	const sd = new Date();
	sd.setTime(startsAt * 1000);
	const ed = new Date();
	ed.setTime(endsAt * 1000);
  
  if ( now.getMonth() == sd.getMonth() && now.getFullYear() == sd.getFullYear() && now.getDate() + 1 == sd.getDate() ) {
		rendered = "Tomorrow";
	} else if ( now.getMonth() == sd.getMonth() && now.getFullYear() == sd.getFullYear() && now.getDate() == sd.getDate() ) {
    
    // is startsAt less than now()?
    // a positive number denotes that startsAt hasn't been reached
    let ts = startsAt - Math.round(Date.now() / 1000);
    if (ts > 0) {
      
      // transform ts into minutes
      ts = Math.round(ts / 60);
      
      // if it's less than 60 minutes, we display in minutes.
      if (ts < 60) {
        let plural = ts == 1 ? " minute" : " minutes";
        rendered = "In " + ts + plural;
      } else {
        // otherwise we display in hours
        // transform ts into hours
        ts = Math.ceil(ts / 60);
        let plural = ts == 1 ? " hour" : " hours";
        rendered = "In " + ts + plural;
      }
      
    } else {
      
      // a positive number denotes that endsAt hasn't been reached
      let te = endsAt - Math.round(Date.now() / 1000);
      if (te > 0) {
        // event is happening now
        rendered = "Happening Now";
      } else {
        // event has ended
        rendered = "Ended";
      }
    }
    
    
	} else {
    // in X days
    
    console.log("startsAt:", startsAt);
    // 24 * 60 * 60 = 86400
    let ts = Math.round( ( startsAt - ( Date.now() / 1000 ) ) / 86400);
    console.log("ts1:", ts);
    
    let plural = ts == 1 ? " day" : " days";
    rendered = "In " + ts + plural;
    
    // add in X week(s)
    // add in X month(s)
    // add in X year(s)
  }

}

</script>